import * as React from "react";

import { useContext } from "react";
import { Button, Grid, Typography, useTheme, Divider } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { AppContext } from "../../contextProviders/AppContext";
import { add, set, addHours, isValid, isTuesday, format } from "date-fns";
import TimePickerComponent from "./TimePicker";
import FixedReturnTimePickerComponent from "./TimePickerFixedReturnTime";
import DatePickerDateInput from "./DateInput";
import { translation } from "../Dictionary";
import { MdSearch } from "react-icons/md";
import { Box } from "@mui/system";
import { useRef } from "react";
import { fi } from "date-fns/locale";
import { DateRangePicker } from "@mui/x-date-pickers-pro";
export default function DatePickerFixedDuration({
  startDateString,
  disableMultiday,
  endDateString,
  handleSelectedTimeFrame,
  defaultTimeFrame,
  hasError,
  endTimeOk,
  fixedTimeFrames,
  startSliderValue,
  endSliderValue,
  dayStart,
  selectedDateRange,
  handleDateChange,
  startTime,
  endTime,
  SLIDER_STEP,
  setStartTime,
  selectedTimeFrame,
  throttle,
  FEATURE_FIXED_RESERVATION_TIMEFRAME,
  setEndTime,
  handleClickContinue,
  selectedPicker,
  setSelectedPicker,
  contentHeigth,
  getMinimumDate,
  startTimeLabel,
  returnTimeLabel,
}) {
  const {
    mobileViewPort,
    selectedCompany,
    language,
    reservationStart,
    reservationReturn,
    FEATURE_FIXED_RESERVATION_DURATION,
  } = useContext(AppContext);
  const theme = useTheme();
  const containerRef = useRef();
  //
  const handleTimeChange = (timeValue) => {
    setStartTime(timeValue);
    setEndTime(addHours(timeValue, selectedTimeFrame));
  };
  const [openCalendar, setopenCalendar] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  // This directs the calendar popper to where it should be,
  // Not the most elegant solution...
  React.useEffect(() => {
    if (containerRef?.current) {
      if (anchorEl === null && selectedPicker === "calendar") {
        setAnchorEl(containerRef.current);
      }
    }
  }, [containerRef, anchorEl, selectedPicker]);

  const handleCloseCalendar = () => {
    if (!reservationStart) {
      setSelectedPicker("startTime");
    } else {
      setSelectedPicker(null);
    }
  };

  return (
    <Box
      sx={{
        justifyContent: "space-evenly",
        alignItems: "center",
        position: "relative",
        transition: "ease-in-out 150ms",
        display: "flex",
        flexDirection: "row",
        width: "60%",
      }}
    >
      <Divider orientation="vertical" flexItem variant="middle" />

      <Box sx={{ width: "35%" }} ref={containerRef}>
        <DateRangePicker
          disableMaskedInput
          disablePast
          calendars={mobileViewPort ? 1 : 2}
          displayStaticWrapperAs="desktop"
          value={selectedDateRange}
          onChange={(newValue) => {
            handleDateChange(newValue);
          }}
          PaperProps={{ style: { borderRadius: "14px", marginTop: "5px" } }}
          renderInput={(params) => {
            const customProps = {
              ...params,

              focused: selectedPicker === "calendar" ? true : false,
            };

            return (
              <Box
                onClick={() => setSelectedPicker("calendar")}
                sx={{ display: "flex", width: "100%" }}
              >
                <DatePickerDateInput
                  contentHeigth={contentHeigth}
                  id={"fixed-duration-picker"}
                  pickerProps={customProps}
                  selectedPicker={selectedPicker}
                  setSelectedPicker={setSelectedPicker}
                />
              </Box>
            );
          }}
        />
      </Box>

      <Divider orientation="vertical" variant="middle" flexItem />
      <Box sx={{ width: "35%" }}>
        <Box
          sx={{
            display: "flex",
            //  height: contentHeigth,
            flexDirection: "column",
            flex: 1,
            justifyContent: "flex-start",
            alignItems: "flex-start",
            backgroundColor: "white",
            borderRadius: "10px",
            //    boxShadow: pickerFocused ? theme.shadows[2] : "transparent",
            //      border: customProps.error ? "1px red solid" : undefined,
            justifyContent: "center",
            alignItems: "center",
            transition: "ease-in-out 250ms",
            bgcolor: "transparent",
            //cursor: "",
            /*  "&:hover": {
              bgcolor: "rgba(0,0,0,0.05)",
              boxShadow: theme.shadows[2],
            }, */
          }}
        >
          <Typography color={theme.palette.primary.mainText}>
            {translation.get(language, "End reservation text")}
          </Typography>
          <Typography color={theme.palette.primary.mainText}>
            {isValid(selectedDateRange[1]) &&
              format(selectedDateRange[1], "dd.MM.yyyy", {
                locale: fi,
              })}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

const RangeShortcutsPanel = ({
  children,
  selectedCompany,
  selectedDateRange,
  theme,
  language,
  endTimeOk,
}) => {
  const CalendarTitleContent = ({ language }) => {
    const TitleText = () => {
      if (!selectedCompany)
        return translation.get(language, "Error: No company");
      if (selectedCompany && !selectedDateRange[0])
        return translation.get(language, "Start reservation text");
      if (
        selectedCompany &&
        selectedDateRange[0] &&
        !selectedDateRange[1] &&
        !endTimeOk.hasError
      )
        return translation.get(language, "Select return date");

      if (endTimeOk.hasError === true) {
        return endTimeOk.message;
      }

      if (selectedCompany && selectedDateRange[0] && selectedDateRange[1])
        return translation.get(
          language,
          "Reservation fixed timeframe selected"
        );
    };

    const Title = () => (
      <Typography
        variant="body2"
        sx={{ fontSize: "16px", color: theme.palette.primary.secondaryText }}
        align="center"
      >
        <TitleText />
      </Typography>
    );

    const titleBgColor = () => {
      if (endTimeOk.hasError) {
        return theme.palette.warning.light;
      }
      if (selectedCompany && !selectedDateRange[0]) {
        return theme.palette.primary.dateRangeBgFrom;
      }
      if (selectedCompany && selectedDateRange[0] && !selectedDateRange[1]) {
        return theme.palette.primary.dateRangeBgTo;
      }

      if (selectedCompany && selectedDateRange[0] && selectedDateRange[1]) {
        return theme.palette.primary.dateRangeBgComplete;
      }

      return theme.palette.info.main;
    };

    return (
      <Box
        sx={{
          display: "flex",
          bgcolor: titleBgColor(),
          padding: "5px",
          paddingTop: "15px",
          borderTopLeftRadius: "17px",
          borderTopRightRadius: "17px",
          justifyContent: "center",
        }}
      >
        <Title />
      </Box>
    );
  };

  return (
    <React.Fragment>
      <CalendarTitleContent language={language} />

      <Divider orientation="vertical" />

      {children}
    </React.Fragment>
  );
};
